import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import moment from "moment";
import * as React from "react";
import { useState } from "react";
import { BooleanInput, FormWithRedirect, NumberInput, TextInput, Toolbar } from "react-admin";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import AircraftTypeInput from "../../../../Components/ReferenceFields/AircraftType/AircraftTypeInput";
import CustomerInput from "../../../../Components/ReferenceFields/Customer/CustomerInput";

const AircraftEditForm = props => {
  const [nowDate, setNowDate] = useState<any>(undefined);
  return (
    <FormWithRedirect
      {...props}
      render={(formProps: any) => (
        <Card>
          <form>
            <CardContent>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={2}>
                  <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Creation Information
                    </Typography>
                    <BooleanInput
                      label="Phase Out/In"
                      source="phaseOut"
                      onChange={value => {
                        if (value === true) {
                          formProps.form.change("phaseOutDate", moment.utc().local().format("YYYY-MM-DD HH:mm"));
                        } else {
                          formProps.form.change("phaseOutDate", null);
                        }
                      }}
                    />
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomerInput label="Customer" fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <AircraftTypeInput label="A/C Type" fullWidth />
                    </Box>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput source="acRegistration" label="A/C Registration" fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput source="aircraftMsn" label="A/C MSN" fullWidth />
                    </Box>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="manufacturatedDate" label="Manufacturated Date" fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="joinToFleetDate" label="Join to Fleet Date" fullWidth />
                    </Box>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <NumberInput source="aircraftAge" label="A/C Age" fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="phaseOutDate" label="Phase Out Date" fullWidth disabled />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={true}
              invalid={formProps.invalid}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
            />
          </form>
        </Card>
      )}
    />
  );
};

export default AircraftEditForm;
